import React, { useEffect } from "react";
import "@fontsource/raleway";
import { Box, Typography, Grid } from "@mui/material";
import AOS from "aos";
import "aos/dist/aos.css";
import { ShakeSlow } from "reshake";
import styled from "styled-components";
import { GitHub } from "@mui/icons-material";
AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
  initClassName: "aos-init", // class applied after initialization
  animatedClassName: "aos-animate", // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 120, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 400, // values from 0 to 3000, with step 50ms
  easing: "ease", // default easing for AOS animations
  once: false, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
});
const Tech_Stack = [
  { img: "./HTML.png", text: "HTML 5", w: "17%", w2: "17%" },

  { img: "./CSS.png", text: "CSS 3", w: "20%", w2: "20%" },

  { img: "./Javascript.png", text: "Javascript", w: "20%", w2: "20%" },

  { img: "./Typescript.png", text: "Typescript", w: "20%", w2: "20%" },

  { img: "./React.png", text: "React", w: "20%", w2: "20%" },

  { img: "./react-router.png", text: "React Router", w: "20%", w2: "20%" },

  { img: "./Redux.png", text: "Redux", w: "20%", w2: "20%" },
  { img: "./bootstrap.png", text: "Bootstrap", w: "20%", w2: "30%" },
  { img: "./chakra.png", text: "Chakra UI", w: "20%", w2: "30%" },
  { img: "./express.png", text: "Express", w: "20%", w2: "30%" },
  { img: "./Mongo db.png", text: "Mongo DB", w: "20%", w2: "20%" },
  { img: "./next.png", text: "Next", w: "20%", w2: "30%" },
  { img: "./git.png", text: "Git", w: "20%", w2: "30%" },
  { img: "./github.png", text: "GitHub", w: "20%", w2: "20%" },
];

const TechStack = () => {
  useEffect(() => {
    AOS.init({
      duration: 1800,
    });
    AOS.refresh();
  }, []);

  return (
    <Container>
      <Typography
        variant="h4"
        fontSize={35}
        style={{
          fontFamily: "Great Vibes",
          color: "#04c998",
          display: "inline-block",
          fontSize: "2rem",
          wordSpacing: 0,
        }}
      >
        <span
          style={{
            color: "black",
            fontFamily: "Great Vibes",
            color: "#1b242f",
            display: "inline-block",
            fontSize: "2rem",
          }}
        >
          Technical
        </span>{" "}
        Skills
      </Typography>
      <div
        style={{
          width: "3rem",
          backgroundColor: "#1b242f",
          height: "1vh",
          margin: "auto",
          marginBottom: "2%",
        }}
        data-aos="fade-left"
      ></div>
      <StyledGrid columns={{ xs: 3, sm: 4, md: 6 }} spacing={"20px"} mt="50px">
        {Tech_Stack.map((el, i) => {
          return (
            <div
              data-aos="fade-up"
              key={Math.random()}
              className="skills-card"
              border="3px solid black"
              borderRadius={"20px"}
            >
              <Box
                data-aos="fade-up"
                p="15px"
                display={"flex"}
                justifyContent="center"
              >
                <ShakeSlow>
                  <img
                    data-aos="zoom-in-up"
                    width={el.w2}
                    height={el.h2}
                    className="skills-card-img"
                    src={el.img}
                    alt={el.text}
                  />
                </ShakeSlow>
              </Box>

              <Typography
                fontSize={"20"}
                mb="15px"
                className="skills-card-name"
                style={{ fontFamily: "Raleway" }}
              >
                {el.text}
              </Typography>
            </div>
          );
        })}
      </StyledGrid>
    </Container>
  );
};

const Container = styled.div`
  margin-top: 5%;
  margin-bottom: 5%;
  text-align: center;
`;

const StyledGrid = styled.div`
  display: grid;
  text-align: center;
  grid-template-columns: repeat(2, 1fr);
  grid-template-columns: repeat(3, 1fr);
  @media only screen and (max-width: 960px) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media only screen and (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export default TechStack;
